import { Button as ThemeUiButton } from "theme-ui";

import { CloseIcon } from "components/icons";
import * as styles from "./CloseButton.styles";

export default function CloseButton({ children, ...props }) {
  return (
    <ThemeUiButton variant="unstyled" sx={styles.closeButton} {...props}>
      <CloseIcon />
      {children}
    </ThemeUiButton>
  );
}
